module.exports = __webpack_public_path__ + "img/todo-preview.e5030a3b.svg";